import { Typography } from "@mui/material";
import React from "react";
import { createPortal } from "react-dom";

import classes from "./Modal.module.css";

export default function Modal(props) {
  return createPortal(
    <div
      className={`${classes.modal} ${props.show ? classes.show : ""}`}
      onClick={props.onClose}
    >
      <div
        className={classes["modal-content"]}
        onClick={(e) => e.stopPropagation()}
      >
        <Typography variant="h4" className={classes.modal_heading}>
          {props.title}
        </Typography>
        <Typography
          variant="p"
          style={{
            display: "inline-block",
            fontSize: "18px",
            fontWeight: 600,
            color: "#81878C",
            cursor: "pointer",
          }}
          onClick={() => {
            props.onClose(false);
          }}
        >
          X
        </Typography>
        <div className={classes["modal-body"]}>{props.children}</div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
}
